document.addEventListener("DOMContentLoaded", function () {
  class DynamicFiltersVisibility {
    constructor() {
      this.filtersButton = document.getElementById("filters-button");
      this.facetDrawer = document.getElementById("Facet-Drawer");
      this.tagsWrapper = document.querySelector(".collection-tags-wrapper");
      
      this.init();
    }

    init() {
      this.hideMainFilters();
      
      setTimeout(() => {
        this.checkFiltersAvailability();
        this.setupObservers();
      }, 500);
      
      setTimeout(() => {
        this.checkFiltersAvailability();
      }, 1500);
    }

    hideMainFilters() {
      if (!this.facetDrawer) return;

      const allFilters = this.facetDrawer.querySelectorAll('details.thb-filter.js-filter');
      
      allFilters.forEach(filter => {
        const filterTitle = filter.querySelector('.thb-filter-title');
        if (!filterTitle) return;

        const titleText = filterTitle.textContent.trim().toLowerCase();

        const desktopMainFilters = [
          'price',
          'delivery speed',
        ];

        const alwaysHiddenFilters = [
          'popular',
          'popularity',
          'populares',
          'popularidad',
        ];

        const isDesktopMainFilter = window.innerWidth >= 768 && desktopMainFilters.some(mainFilter => 
          titleText.includes(mainFilter)
        );

        const isAlwaysHiddenFilter = alwaysHiddenFilters.some(hiddenFilter => 
          titleText.includes(hiddenFilter)
        );

        if (isDesktopMainFilter || isAlwaysHiddenFilter) {
          filter.style.display = 'none';
        } else {
          filter.style.display = '';
        }
      });
    }

    checkFiltersAvailability() {
      if (window.innerWidth < 768) {
        this.showFiltersButton();
        return;
      }

      const hasExtraFilters = this.detectExtraFilters();
      
      if (hasExtraFilters) {
        this.showFiltersButton();
      } else {
        this.hideFiltersButton();
      }
      
      this.updateTagsSlider();
    }

    detectExtraFilters() {
      if (!this.facetDrawer) {
        return false;
      }

      const visibleFilters = this.facetDrawer.querySelectorAll(
        'details.thb-filter.js-filter:not([style*="display: none"])'
      );

      let extraFiltersCount = 0;

      visibleFilters.forEach(filter => {
        const filterTitle = filter.querySelector('.thb-filter-title');
        const filterContent = filter.querySelector('.thb-filter-content');
        
        if (!filterTitle || !filterContent) return;

        const titleText = filterTitle.textContent.trim().toLowerCase();
        
        const systemFilters = [
          'popular searches',
          'búsquedas populares',
          'popular',
          'popularity',
          'populares',
          'popularidad',
          'sort by',
          'ordenar por'
        ];

        const isSystemFilter = systemFilters.some(systemFilter => 
          titleText.includes(systemFilter)
        );

        if (!isSystemFilter) {
          const checkboxes = filterContent.querySelectorAll('input[type="checkbox"]');
          
          if (checkboxes.length > 0) {
            extraFiltersCount++;
          }
        }
      });

      const hasExtraFilters = extraFiltersCount > 0;
      return hasExtraFilters;
    }



    showFiltersButton() {
      if (this.filtersButton) {
        this.filtersButton.style.display = "";
        this.filtersButton.style.visibility = "visible";
        this.filtersButton.style.opacity = "1";
        this.filtersButton.classList.remove("hidden", "hide");
        this.filtersButton.classList.add("show");

        if (this.tagsWrapper) {
          this.tagsWrapper.classList.add("has-filters-button");
          this.tagsWrapper.classList.remove("no-filters-button");
        }
        
        document.body.classList.remove("no-extra-filters");
      }
    }

    hideFiltersButton() {
      if (this.filtersButton) {
        this.filtersButton.classList.remove("show");
        this.filtersButton.classList.add("hidden", "hide");
        
        setTimeout(() => {
          if (this.filtersButton && this.filtersButton.classList.contains("hidden")) {
            this.filtersButton.style.display = "none";
            this.filtersButton.style.visibility = "hidden";
            this.filtersButton.style.opacity = "0";
          }
        }, 300);
        
        if (this.tagsWrapper) {
          this.tagsWrapper.classList.remove("has-filters-button");
          this.tagsWrapper.classList.add("no-filters-button");
        }
        
        document.body.classList.add("no-extra-filters");
      }
    }

    updateTagsSlider() {
      if (window.globalCollectionTagsSlider && typeof window.globalCollectionTagsSlider.checkFiltersButton === 'function') {
        window.globalCollectionTagsSlider.checkFiltersButton();
      }
      
      if (!window.globalCollectionTagsSlider && window.CollectionTagsSlider) {
        setTimeout(() => {
          const slider = new window.CollectionTagsSlider(
            ".collection-tags",
            ".collection-tags-nav--prev",
            ".collection-tags-nav--next",
            ".collection-tags-indicator"
          );
          window.globalCollectionTagsSlider = slider;
        }, 100);
      }
    }

    setupObservers() {
      if (this.facetDrawer) {
        const observer = new MutationObserver((mutations) => {
          let shouldRecheck = false;
          
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const isActive = this.facetDrawer.classList.contains('active');
              if (isActive) {
                setTimeout(() => {
                  this.hideMainFilters();
                  this.checkFiltersAvailability();
                }, 100);
                return;
              }
            }
            
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.matches && node.matches('details.thb-filter.js-filter')) {
                    shouldRecheck = true;
                  } else if (node.querySelector && node.querySelector('details.thb-filter.js-filter')) {
                    shouldRecheck = true;
                  }
                }
              });
              
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.matches && node.matches('details.thb-filter.js-filter')) {
                    shouldRecheck = true;
                  } else if (node.querySelector && node.querySelector('details.thb-filter.js-filter')) {
                    shouldRecheck = true;
                  }
                }
              });
            }
          });
          
          if (shouldRecheck) {
            setTimeout(() => {
              this.hideMainFilters();
              this.checkFiltersAvailability();
            }, 100);
          }
        });

        observer.observe(this.facetDrawer, { 
          childList: true, 
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      window.addEventListener('popstate', () => {
        setTimeout(() => {
          this.checkFiltersAvailability();
        }, 200);
      });

      document.addEventListener('filtersUpdated', () => {
        setTimeout(() => {
          this.checkFiltersAvailability();
        }, 300);
      });
    }


  }

  const dynamicFiltersVisibility = new DynamicFiltersVisibility();

  document.addEventListener('facet:updated', () => {
    setTimeout(() => {
      dynamicFiltersVisibility.checkFiltersAvailability();
    }, 500);
  });

  let currentPath = window.location.pathname;
  const pathObserver = new MutationObserver(() => {
    if (window.location.pathname !== currentPath) {
      currentPath = window.location.pathname;
      setTimeout(() => {
        dynamicFiltersVisibility.checkFiltersAvailability();
      }, 1000);
    }
  });

  pathObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
}); 